import { TModelNumberRow } from "./ModelNumbers"
import { ArrowIcon } from "components/ui/icons/quotations/ArrowIcon"
import { DetachIcon } from "components/ui/icons/detachIcon/DetachIcon"
import type { ColumnsType } from "antd/es/table"
import style from "./ModelNumbers.module.scss"

const { toModelNumber } = style

const isQuotationLocked = import.meta.env.VITE_LOCK_QUOTATION_FEATURE === "true"

type ModelNumbersColumnsParams = {
	modelNumberToId: Record<string, number>
	onDetach: (modelNumberId: number, modelNumberName: string) => void
}

export const ModelNumbersColumns = ({ modelNumberToId, onDetach }: ModelNumbersColumnsParams) => {
	const cols: ColumnsType<TModelNumberRow> = [
		{
			title: "MODEL NUMBER",
			dataIndex: "modelNumber",
			key: "modelNumber",
		},
		{
			title: "WIDTH",
			dataIndex: "width",
			key: "width",
		},
		{
			title: "HEIGHT",
			dataIndex: "height",
			key: "height",
		},
		{
			title: "DEPTH",
			dataIndex: "depth",
			key: "depth",
		},
	]

	if (!isQuotationLocked) {
		cols.push({
			title: "",
			key: "goTo",
			render: (_, record) => {
				const id = modelNumberToId[record.modelNumber]
				const url = `/configuration/model-numbers?modelNumberID=${id}`
				return (
					<a href={url} target="_blank" rel="noopener noreferrer" className={toModelNumber}>
						<span>Go to model number</span>
						<ArrowIcon />
					</a>
				)
			},
		})
	}

	cols.push({
		title: "",
		key: "detach",
		render: (_, record) => {
			const id = modelNumberToId[record.modelNumber]
			return (
				<button onClick={() => onDetach(id, record.modelNumber)}>
					<DetachIcon />
				</button>
			)
		},
	})

	return cols
}
